module.exports = __webpack_public_path__ + "static/media/stepper-configure-active.c3776a5e.svg";